module.exports = __webpack_public_path__ + "static/japan14-516344fa81ae58cbd5b7db6e7fa3e6a2.jpg";